export const highchartsIconSeriesTypes = ["windbarb", "wavebarb", "weathersymbol"];
